































# import settings from '@/settings'
import t from '@/utils/tools'
import n from '@/utils/notifications'
import q from '@/graphql/query'

export default {
    name: 'company_skills'

    watch:
        '$store.state.selected_company': (value)->
            @get_skills()

    data: ()->
        alert: false
        loading: true
        search: ''
        pager_count: 5
        current_page: 1
        page_size: 10
        skills: []

    computed:
        data_filtered: ()->
            self = @
            data = @skills.filter (x) ->
                user = false
                for uss in x.user_skill_set
                    if uss.user.fullnamejobs.toLowerCase().includes(self.search.toLowerCase())
                        user = true
                        # Added Normalize('NFD') to remove all accents once user search
                return !self.search || x.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.name.toLowerCase().includes(self.search.toLowerCase())
            return data

        data_paged: ()->
            data = @data_filtered.slice(((@current_page - 1) * @page_size), (@page_size * @current_page))
            return data

    methods:
        has_access_right: t.has_access_right

        listen_sort: ({ column, prop, order })->
            # console.log "LISTEN", column, prop, order
            self = @
            @skills.sort (a,b)->
                modifier = 1
                if order == 'descending'
                    modifier = -1
                return a[prop].toLowerCase().localeCompare(b[prop].toLowerCase())*modifier
            # @skills.sort (a,b)->
            #     modifier = 1
            #     if order == 'descending'
            #         modifier = -1
            #     if a[prop].toLowerCase() < b[prop].toLowerCase()
            #         return -1 * modifier
            #     if a[prop].toLowerCase() > b[prop].toLowerCase()
            #         return 1 * modifier
            #     return 0
            # console.log "SKILLS SORT ", @skills

        handle_size_change: (val)->
            @page_size = val

        handle_current_change: (val)->
            @current_page = val

        edit_user: (user)->
            if @has_access_right('users_skills_show') and @has_access_right('users_show') and user.editable
                @$store.commit('set_selected_app_user', {'uid':user.uid, 'lastname':user.user_info.lastname, 'firstname':user.user_info.firstname})
                localStorage.setItem("selected_app_user", JSON.stringify(@$store.state.selected_app_user))
                @$router.push({name:'company_users_skills', params: {uid: user.uid, direct: true}})
            else if @has_access_right('users_skills_self_show') and @has_access_right('users_self_show') and user.uid == @$store.state.user_datas.app_user.uid
                @$router.push({name:'users_skills', params: {uid: user.uid, direct: true}})
            else
                n.warning("Vous n'avez pas les droits nécessaires")
            return

        get_skills: ()->
            self = @
            @loading = true
            q.run('get_company_skill_set', [@$store.getters.current_company.uid, ["activity", "skill", "capacitation"]])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("company_skills: get_skills: then", e.message)
                else
                    # console.log "RUN QUERY SKILLS : ", resp.body.data.company_skill_set
                    self.skills = resp.body.data.company_skill_set
                    self.loading = false
                    if self.skills.length == 0
                        self.alert = true
                    else
                        self.alert = false
            .catch (resp)->
                n.catch_error(resp, "company_skills: get_skills()")
        
    beforeMount: ()->
        @get_skills()
}
